import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'; import React from 'react'

export const Loader = () => {
  return <Box sx={{ display: 'flex', justifyContent: 'center', alignItem: 'center' }}>
      <CircularProgress sx={{ color: '#09B5EC' }} />
  </Box>
}

export default Loader
